const purchase = {
  state: {
    goodsTypeList: [], // 物资类型
    receiveSendTypeList: [], // 收发货类型
    suppliesTypeList: [] // 物资类别
  },
  getters: {
    goodsTypeList: state => state.goodsTypeList,
    receiveSendTypeList: state => state.receiveSendTypeList,
    suppliesTypeList: state => state.suppliesTypeList
  },
  mutations: {
    goodsTypeList: (state, goodsTypeList) => {
      state.goodsTypeList = goodsTypeList
    },
    receiveSendTypeList: (state, receiveSendTypeList) => {
      state.receiveSendTypeList = receiveSendTypeList
    },
    suppliesTypeList: (state, suppliesTypeList) => {
      state.suppliesTypeList = suppliesTypeList
    }
  },
  actions: {
    handleGoodsTypeList (goodsTypeList, data) {
      goodsTypeList.commit('goodsTypeList', data)
    },
    handleReceiveSendTypeList (receiveSendTypeList, data) {
      receiveSendTypeList.commit('receiveSendTypeList', data)
    },
    handleSuppliesTypeList (suppliesTypeList, data) {
      suppliesTypeList.commit('suppliesTypeList', data)
    }
  }
}

export default purchase
